import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Sunny"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 9.00391C13.6569 9.00391 15 10.3471 15 12.0039C15 13.6608 13.6569 15.0039 12 15.0039C10.3431 15.0039 9 13.6608 9 12.0039C9.00207 10.3479 10.344 9.00597 12 9.00391ZM12 7.50391C9.51472 7.50391 7.5 9.51863 7.5 12.0039C7.5 14.4892 9.51472 16.5039 12 16.5039C14.4853 16.5039 16.5 14.4892 16.5 12.0039C16.5 9.51863 14.4853 7.50391 12 7.50391ZM4.04561 5.1099L5.10761 4.0494L7.73636 6.6789L6.67511 7.7394L4.04561 5.1099ZM1.5 11.2539H5.25V12.7539H1.5V11.2539ZM4.04561 18.8987L6.67511 16.2692L7.73561 17.3297L5.10686 19.9592L4.04561 18.8987ZM11.25 18.7539H12.75V22.5039H11.25V18.7539ZM16.2654 17.3289L17.3259 16.2684L19.9554 18.8979L18.8949 19.9584L16.2654 17.3289ZM18.75 11.2539H22.5V12.7539H18.75V11.2539ZM16.2654 6.67814L18.8949 4.04864L19.9554 5.10914L17.3259 7.73864L16.2654 6.67814ZM11.25 1.50391H12.75V5.25391H11.25V1.50391Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Sunny.vue"]]);
